import GlobalStyles from "./Global/globalStyles";
import Routes from "./Routes";

const App = () => {
  return (
    <>
      <Routes />
      <GlobalStyles />
    </>
  );
};

export default App;
